<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.04.19</b> - Некоторые исправления ошибок</p>
    <div class="ml-5 pb-4 text-green-400">
      <div>
        Не дайте себя обмануть кажущимся незначительным обновлением ~ Я был *очень* занят
        расширением команды разработчиков (!!!), и подготовкой к предстоящему запуску на CrazyGames.
        Время вывести это на новый уровень ~~~ ~~ ~
      </div>

      <div class="font-bold mt-2">Исправления ошибок</div>
      <ul class="ml-4 list-disc">
        <li>Исправлены бесконечные циклы, которые могли возникать при экипировке сумок</li>
        <li>Исправлены ошибки интерфейса при перетаскивании экипированных сумок между слотами</li>
        <li>Исправлены ошибки на экране редактирования экипировки</li>
        <li>Исправлены проблемы с некорректным обновлением системы турниров в таверне</li>
        <li>Исправлены проблемы с отображением текста на тайлах Пещер</li>
      </ul>
    </div>
  </div>
</template>
